import Form from '@utils/form'
import options from './config/options'
import SupplierSetting from './components/supplier-setting/index.vue'
import { validatorEffectiveDate, validatorExpirationDate } from './config/validator'
import DateTip from './components/date-tip.vue'

export default new Form('performance.formulaConfig')
  .url('/srmGeneralFormula/addSrmGeneralFormula', process.env.VUE_APP_PURCHASE_API)
  .title('formTitle.baseInfo')
  .add('purOfficeNo').select('/purchaseUnit/getPurchaseUnitPage')
  .add('formulaNo').required()
  .add('formulaName').required()
  .add('rationFormulaId').select('/srmRationFormula/getSrmRationFormulaPageByParams').required()
  .add('rationWeight').merge('number').attrs({ min: 0, max: 100 }).on('change', (vm: any) => { vm.data.qualitativeWeight = 100 - vm.data.rationWeight }).required().default(0)
  .add('qualitativeFormulaId').select('/srmQualitativeFormula/getSrmQualitativeFormulaPageByParams').required()
  .add('qualitativeWeight').merge('number').attrs({ min: 0, max: 100 }).on('change', (vm: any) => { vm.data.rationWeight = 100 - vm.data.qualitativeWeight }).required().default(0)
  .add('effectiveDate').component(DateTip).bind('content', 'performance.formulaConfig.effectiveDateTooltip').label('effectiveDate').placeholder('common.datePlaceholder').rules({ trigger: 'change', validator: validatorEffectiveDate }).required()
  .add('expirationDate').component(DateTip).bind('content', 'performance.formulaConfig.expirationDateTooltip').label('expirationDate').placeholder('common.datePlaceholder').rules({ trigger: 'change', validator: validatorExpirationDate }).required()
  .add('timingTaskStatus').op(options).default('1')
  .add('examinationCycle').merge('number').required().bind('disabled', true).default('1')
  .add('assessmentDate').merge('number').placeholder('assessmentDatePlaceholder').attrs({ min: 1, max: 28 }).required()
  .add('remarks').merge('textarea')
  .addGroup('formTitle.supplierSetting')
  .add('list').component(SupplierSetting).label().bindFormItem('labelWidth', '0').col(24)
  .end()
